import { render, staticRenderFns } from "./MalKabulDetayOlculenDeger.vue?vue&type=template&id=2da08c16&"
import script from "./MalKabulDetayOlculenDeger.vue?vue&type=script&lang=js&"
export * from "./MalKabulDetayOlculenDeger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports